export const UserType = {
    admin: 'admin',
    user: 'user',
};
